import * as yup from 'yup';

export const botMessageSchema = yup.object().shape({
  channelId: yup.string().required("L'id est obligatoire"),
  message: yup.string().required('Le message est obligatoire'),
});
